<template>
  <v-container class="pa-1" fluid grid-list-xs>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card v-if="user.balance" style="margin-bottom: 20px;">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox class="left" v-model="shouldUseBalance"></v-checkbox>
                <div class="ml-5 mt-1" @click="toggleUseBalance" style="cursor: pointer;">
                  <h2>Guthaben verwenden ({{ (user.balance / 100.).toFixed(2).replace('.', ',') }} €)</h2>
                  Der Rechnungsbetrag wird mit dem Guthaben verrechnet.
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <h2 v-if="shouldUseBalance && user.balance >= totalSum">Der Rechnungsbetrag wird vollständig mit dem Guthaben bezahlt.</h2>

        <v-card v-if="!shouldUseBalance || (shouldUseBalance && user.balance < totalSum)">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex v-if="shouldUseBalance" xs12>
                <h2>Das Guthaben deckt den Rechnungsbetrag nicht vollständig. Bitte wählen Sie eine Zahlart aus, um den Restbetrag zu zahlen.</h2>
              </v-flex>

              <v-flex v-if="shouldUseBalance" xs12>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs12>
                <v-checkbox class="left" v-model="method" value="invoice"></v-checkbox>
                <div class="ml-5 mt-1" @click="method = 'invoice'" style="cursor: pointer;">
                  <h2>Rechnung</h2>
                  {{ $t('pay_with_invoice', [event.days_until_pay_date]) }}
                </div>
              </v-flex>

              <v-flex xs12>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs12 sm8>
                <v-checkbox class="left" v-model="method" value="pay_pal"></v-checkbox>
                <div class="ml-5 mt-1" @click="method = 'pay_pal'" style="cursor: pointer;">
                  <h2>PayPal</h2>
                  Jetzt mit Paypal zahlen
                </div>
              </v-flex>
              <v-flex xs12 sm4 @click="method = 'pay_pal'" style="cursor: pointer;">
                <img
                    class="hidden-xs-only right mt-2"
                    src="https://www.paypalobjects.com/webstatic/de_DE/i/de-pp-logo-150px.png"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12="xs12">
        <v-btn class="right mx-0 pl-2 pr-2" :disabled="!canContinue" color="primary" @click.native="next"
               v-t="'continue'"></v-btn>
        <v-btn class="right" flat @click.native="$emit('back')" v-t="'back'"></v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: {
    event: {
      type: Object
    },
    value: {
      type: String,
      default: ''
    },
    starters: {
      type: Array,
      default: () => []
    },
    useBalance: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    method() {
      this.$emit('update:value', this.method);
    },
    shouldUseBalance() {
      this.$emit('update:use-balance', this.shouldUseBalance)
    }
  },
  data() {
    return {
      method: null,
      panel: 0,
      shouldUseBalance: false
    }
  },
  computed: {
    totalSum() {
      return _.sumBy(this.starters, s => _.sumBy(s.starter_registrations, 'price'));
    },
    canContinue() {
      return !!this.method;
    },
    ...mapState(['user'])
  },
  mounted() {
    if (this.value) {
      this.method = this.value;
    }

    if (this.useBalance) {
      this.shouldUseBalance = true;
    }
  },
  methods: {
    toggleUseBalance () {
      this.shouldUseBalance = !this.shouldUseBalance
      if (this.shouldUseBalance && this.user.balance >= this.totalSum) {
        this.method = this.event.generate_invoices ? 'invoice' : 'no_payment';
      } else if (!this.shouldUseBalance && this.user.balance >= this.totalSum) {
        this.method = null
      }
    },
    next () {
      this.$emit('forward')
    }
  }
}
</script>
